import React from 'react';
import stylesP from './pearlDoser.module.css';
import styles from './recipes.module.css';
import {cl} from '../../../components/utils/utils';

export default class Recipes extends React.Component {
  constructor(props) {
    super(props);
//     cl(props)
    this.nameInputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.editMode === 'recName' &&
      prevProps.editMode !== 'recName'
    ) {
      const el = this.nameInputRef.current;
      if (el) {
        el.focus();
        el.select();
      }
    }
  }

  render() {
    const { names, selectedId, editName, editMode = '', onChange } = this.props;
    const sorted = [...names].sort((a, b) => a.name.localeCompare(b.name));

    return (
      <div className={[styles.root,stylesP.pearlDoser].join(' ')}>
        <div className={styles.row2}>
          {editMode === 'recName' ? (
            <input
              id="editRecNameE"
              ref={this.nameInputRef}
              type="text"
              className={styles.nameInput}
              value={editName}
              onChange={(e) => onChange({ type: 'name', value: e.target.value })}
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <span
              id="editRecNameT"
              className={styles.recipeNameClickable}
              onClick={() => onChange({ type: 'edit', value: 'recName' })}
            >
              {selectedId === 'none' ? 'No Recipe Selected' : editName}
            </span>
          )}
        </div>
        <div className={styles.row1}>
          <select
            className={stylesP.stdSelect}
            value={selectedId}
            onChange={(e) => onChange({ type: 'select', value: e.target.value })}
          >
            <option value="none">Select Recipe</option>
            <option value="new">New Recipe</option>
            {sorted.map(({ recipeId, name },i) => (
              <option key={i} value={recipeId}>
                {name}
              </option>
            ))}
          </select>
          <button
            className={stylesP.fillBut}
            type="button"
            onClick={() => onChange({ type: 'delete' })}
          >
            Delete
          </button>
        </div>
      </div>
    );
  }
}
